












































import { Vue, Prop, Component } from "vue-property-decorator";
import { DocTemplate as IDocTemplate } from "@/api/models/doc-template";
import documentTemplates, {
  DocumentTemplatesListParams
} from "@/getinfo-api/document-templates";
import { DocTemplatesList as IDocTemplatesList } from "@/api/models/doc-templates-list";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { DocTemplateFileCreate as IDocTemplateFileCreate } from "@/api/models/doc-template-file-create";
import { FileItem as IFileItem } from "@/api/models/file-item";
import api from "@/getinfo-api";
import moment from "moment/moment";
import CustomButton from "@/components/form/CustomButton.vue";
@Component({
  components: { CustomButton }
})
export default class DocTemplateGenerate extends Vue {
  @Prop() type!: string;
  @Prop() companyId!: string;
  @Prop() entityId!: string;
  @Prop() entitysData!: Array<any>;
  @Prop() entityNumber?: string;
  @Prop({ default: false }) scopeCreate!: boolean;
  @Prop() savedFileName?: string;
  generatedFile!: IFileItem;
  generateFiles: Array<IFileItem> = [];
  templates: Array<IDocTemplate> = [];
  generatedSpinner: boolean = false;
  selectedTemplate!: IDocTemplate | undefined;
  fileName!: string;
  count: number = 0;

  data() {
    return {
      selectedTemplate: undefined,
      fileName: undefined,
      generatedFile: undefined
    };
  }

  getDocTemplates() {
    let params: DocumentTemplatesListParams = {
      companyId: this.companyId,
      type: this.type,
      limit: 60
    };
    documentTemplates(params).then((res: { data: IDocTemplatesList }) => {
      this.templates = res.data.items;
      this.generateName();
    });
  }

  goToCreateTemplate() {
    let link = this.$router.resolve({ name: "docTemplatesCreate" });
    window.open(link.href, "_blank");
  }

  downloadFile() {
    let linkToFile = document.createElement("a");
    if (this.generatedFile.url) {
      linkToFile.href = this.generatedFile.url;
      linkToFile.target = "_blank";
      //@ts-ignore
      linkToFile.download = this.generatedFile.url.split("/").pop();
      linkToFile.click();
    }
  }

  generateScope() {
    this.entitysData.forEach(el => {
      this.generateTemplate(el.id, el.number);
    });
  }

  //@todo Перевести названия генерируемых папок на английский
  selectFolderForGeneratedFiles(item: string) {
    const folderNames: { [key: string]: string } = {
      contract: "Сформированные договоры",
      bill: "Сформированные счета",
      act: "Сформированные акты",
      enrollment_order: "Сформированные приказы о зачислении",
      expulsion_order: "Сформированные приказы об отчислении",
      education_protocol: "Сформированные протоколы обучения",
      final_document: "Сформированные итоговые документы"
    };
    return folderNames[item];
  }

  translateType(type: string) {
    const translateFields: { [key: string]: string } = {
      contract: `${this.$tc(this.$translate.Contract)}`,
      bill: "Счет",
      act: "Акт",
      enrollment_order: "Приказ_о_зачислении",
      expulsion_order: "Приказ_об_отчислении",
      education_protocol: "Протокол_обучения",
      final_document: "Итоговый_документ"
    };

    return translateFields[type] ? translateFields[type] : type;
  }

  generateTemplate(id = this.entityId, number: any = undefined) {
    this.generatedSpinner = true;
    const entityName: string | undefined = this.selectedTemplate?.settings[0]
      .name;

    if (entityName) {
      let params: IDocTemplateFileCreate = {
        name: number
          ? `${this.translateType(this.type)}-${number + "-"}${moment().format(
              "DD.MM.YYYY-LT"
            )}${this.count === 0 ? "" : " " + this.count}`
          : `${this.fileName}${this.count === 0 ? "" : " " + this.count}`,
        folder: this.selectFolderForGeneratedFiles(this.type)
          ? this.selectFolderForGeneratedFiles(this.type)
          : undefined,
        entities: {
          [entityName]: id // entity name
        }
      };

      if (this.selectedTemplate?.id) {
        api.DocTemplateApi.generate(this.selectedTemplate.id, params)
          .then((res: { data: IFileItem }) => {
            this.count++;
            this.$emit("getFileId", [res.data.id]);
            if (this.scopeCreate) {
              let linkToFile = document.createElement("a");

              this.generateFiles.push(res.data);
              if (res.data && res.data.url) {
                linkToFile.href = res.data.url;
                linkToFile.target = "_blank";
                //@ts-ignore
                linkToFile.download = res.data.url.split("/").pop();
                linkToFile.click();
              }

              this.$store.dispatch("successToast", {
                message: this.$tc(this.$translate.Successful)
              });
            } else {
              this.generatedFile = res.data;
              this.downloadFile();
              this.$store.dispatch("successToast", {
                message: this.$tc(this.$translate.Successful)
              });
            }
          })
          .catch(
            (err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
              this.$store.dispatch("errorException", {
                vm: this,
                error: err.response
              });
            }
          )
          .finally(() => {
            this.generatedSpinner = false;
          });
      }
    }
  }

  generateName() {
    const date = moment().format("DD.MM.YYYY-LT");
    this.fileName = this.savedFileName
      ? this.savedFileName
      : `${this.translateType(this.type)}-${
          this.entityNumber ? this.entityNumber + "-" : ""
        }${date}`;
  }

  created() {
    this.getDocTemplates();
  }
}
